import { Record, Map } from 'immutable';

const LikeTypeRecord = Record({
  id: undefined,
  name: undefined,
  text: undefined,
  _links: new Map(),
  _forms: new Map()
});

class LikeType extends LikeTypeRecord {

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default LikeType;


// WEBPACK FOOTER //
// ./src/api/models/likeType.js